import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../redux/store/store';
import { navigate } from '../../redux/slice/layoutSlice';
import { LanguageSwitch } from '../../components/LanguageSwitch';
import { ThemeSwitch } from '../../components/ThemeSwitch';
import { IconUser } from '../../components/icons';
import { useT } from '../../i18n';

/**
 * Preferences — the webapp's counterpart to the mobile app's Settings screen
 * (mobileapp/src/screens/settings/SettingsScreen.tsx), reachable from the
 * Settings group in the sidebar.
 *
 * Appearance and language so far. Colour scheme and notification channels are
 * the mobile screen's other sections and are already stored per user by the
 * same `updateMyPreferences` mutation, so each becomes one more panel here.
 */
const Preferences = () => {
  const dispatch = useDispatch<AppDispatch>();
  const t = useT();

  return (
    <div className="dashboard">
      <section className="panel">
        <div className="panel__head">
          <div>
            <h2>{t('settings.title')}</h2>
            <p className="panel__sub">{t('settings.subtitle')}</p>
          </div>
        </div>

        <div className="panel__body">
          <h3 className="panel__section-title">{t('settings.appearance')}</h3>
          <p className="panel__sub">{t('settings.appearanceHint')}</p>
          <div className="prefs__control">
            <ThemeSwitch />
          </div>

          <h3 className="panel__section-title">{t('settings.language')}</h3>
          <p className="panel__sub">{t('settings.languageHint')}</p>
          {/* No Save button on either control: the choice is written locally
              and pushed to the account immediately (see
              theme/PreferencesContext). */}
          <div className="prefs__control">
            <LanguageSwitch />
          </div>
        </div>
      </section>

      <section className="panel">
        <div className="panel__head">
          <div>
            <h2>{t('settings.account')}</h2>
            <p className="panel__sub">{t('settings.accountHint')}</p>
          </div>
          <div className="toolbar">
            <button
              type="button"
              className="btn"
              onClick={() => dispatch(navigate('/profile'))}
            >
              <IconUser size={16} /> {t('settings.openProfile')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Preferences;
